(function () {
    'use strict';

    angular.module('AngularAdmin').factory('PermissionSvc', ['$http', '$q', '$rootScope', 'PlantSvc', function ($http, $q, $rootScope, PlantSvc) {
        var PermissionSvc = {
            permissionCache: undefined,
            permissionCache_by_id: undefined,
            getPermissions: function(force_reload) {
                var deferred = $q.defer();
                if(!PermissionSvc.permissionCache || force_reload) {
                    var url = String.format('/get_permissions/');
                    PermissionSvc.permissionCache = deferred.promise;
                    $http.get(url, { }).then(function (data) {
                        PermissionSvc.permissionCache_by_id = PermissionSvc.listToIdMap(data.data);
                        deferred.resolve(data);
                    });
                } else {
                    deferred.resolve(PermissionSvc.permissionCache);
                }
                return deferred.promise;
            },
            getPlantPermissions: function(plant_id, force_reload) {
                var deferred = $q.defer();
                plant_id = parseInt(plant_id);

                PermissionSvc.getPermissions(force_reload).then(function (data) {
                    deferred.resolve(PermissionSvc.permissionCache_by_id[plant_id]);
                }, function (error) {
                    console.error('Error loading permissions', error);
                    deferred.reject(error);
                });

                return deferred.promise;
            },
            listToIdMap: function (list) {
                var map = {};
                for (var i = list.length - 1; i >= 0; i--) {
                    map[list[i].plant_id] = list[i];
                }
                return map;
            }
        };

        // Initialize
        $rootScope.PermissionSvc = PermissionSvc;
        return PermissionSvc;
    }]);
})();